<template>
  <!--导入房间-->
  <div class="advanced-form">
    <div class="card">
      <div class="card-head">
        <h3>导入说明</h3>
      </div>
      <div class="card-body">
        <p :style="{lineHeight: '25px'}">
          请先创建单元数据，导入文件中从左到右依次为：房间编号，建筑面积<br>导入数据从第二行开始
        </p>
      </div>
    </div>

    <div class="card">
      <div class="card-head">
        <h3>下载模板，填写数据</h3>
      </div>
      <div class="card-body">
        <a-button @click="downTemplate" type="primary" :disable="disableDown">下载模板</a-button>
      </div>
    </div>

    <div class="card">
      <div class="card-head">
        <h3>选择要导入的小区楼栋，设置选项后上传</h3>
      </div>
      <div class="card-body">
        <x-addEdit
          :style="{width: '500px'}"
          :itemLayout="itemLayout"
          :formList="formList"
          :addParam="addParam"
          :editParam="editParam"
          :detailParam="detailParam"
        >
        </x-addEdit>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect, mixin.importRoomAuth],
  name: 'importRoom',
  data () {
    let decoratorOptions = {
      community_id: {
        rules: [{ required: true, message: '请选择所属小区' }]
      },
      building_id: {
        rules: [{ required: true, message: '请选择所属楼栋' }]
      },
      unit_id: {
        rules: [{ required: true, message: '请选择所属单元' }]
      },
      file_id: {
        rules: [{ required: true, message: '请选择房间数据' }]
      }
    };
    return {
      downloadUrl: '',
      disableDown: false,
      itemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 15 }
      },
      formList: [
        {
          label: '所属小区',
          inputType: 'select',
          options: [],
          placeholder: '请选择小区',
          handle: (e) => {
            this.$children[1].resetSubValue(['building_id', 'unit_id'], e);
            this.communityChange(1, e, 'formList');
          },
          props: ['community_id', decoratorOptions.community_id]
        },
        {
          label: '所属楼栋',
          inputType: 'select',
          options: [],
          placeholder: '请选择楼栋',
          handle: (e) => {
            this.buildingChange(2, e, 'formList');
            this.$children[1].resetSubValue(['unit_id'], e);
          },
          props: ['building_id', decoratorOptions.building_id]
        },
        {
          label: '所属单元',
          inputType: 'select',
          options: [],
          placeholder: '请选择单元',
          props: ['unit_id', decoratorOptions.unit_id]
        },
        {
          label: '房间数据',
          inputType: 'upload',
          options: [],
          placeholder: '',
          name: 'file_id',
          fileList: [],
          uploadParam: {
            action: this.$store.state.uploadUrl,
            headers: {},
            accept: this.$store.state.excelAccept
          },
          props: ['file_id', decoratorOptions.file_id]
        }
      ],
      addParam: {
        url: '/room/import',
        reqHandle: '', // this.reqHandle
        resHandle: this.addResHandle
      },
      editParam: {},
      detailParam: {}
    };
  },
  created () {
    this.btnAuth();
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.communitySelect(0, 'formList', 1);

      this.$get({
        url: '/select_list/roomfile_url',
        params: {}
      }).then(({data}) => {
        this.downloadUrl = data;
      });
    },
    downTemplate () {
      let a = document.createElement('a');
      a.href = this.downloadUrl;
      a.click();
    },
    detailResHandle (res) {
      console.log('处理详情返回数据: ', res);
      return res;
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      let codeType = { 1: 'success', 2: 'warn' };
      this.$message[codeType[res.code]](res.msg).then((res) => {
        this.$router.go(-1);
      });
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/baseData/room/importRoom.vue